import React, { Component } from 'react';
import Spinner from 'react-spinkit';

import Chart from './YoutubeChart';

import './App.css';

const chartUrl = 'http://public.dzautner.com/tow_youtubes.json';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      loading: true,
    };
  }
  async componentWillMount() {
    const response = await fetch(chartUrl);
    const data = await response.json();
    const normalized = this._normalizeData(data)
    this.setState({
      data: normalized,
      dataLoaded: true,
    })
  }
  _urlToId(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }
  _normalizeData(data) {
    return Object.keys(data).map(date => {
      return {
        ids: Array.from(new Set(data[date].map(post => {
            return this._urlToId(post.u);
        }).filter(id => !!id))),
        date,
      }
    }).sort((d1, d2) =>  d1.date > d2.date ? 1 : -1).slice(11);
  }

  _loader() {
    return <Spinner spinnerName="cube-grid" className="loader" />;
  }
  _chart() {
    return <Chart isReady={() => this.setState({loading: false})} data={this.state.data}/>;
  }
  render() {
    return (
      <div className="App">
        {this.state.loading && this._loader()}
        <div hidden={this.state.loading && !this.state.spriteLoader}>
          {this.state.dataLoaded && this._chart()}
        </div>
        <img style={{display: 'none'}} src="./static/media/tn.952f0d07.png" onLoad={() => this.setState({
            spriteLoader: true
        })}/>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/